import { featureToggleSelector } from './featureToggleSelector';
import { IState } from '../../store';

export const selectIsNewbuildingBrokerFlatBannerRedesignEnabled = (state: IState) => {
  return featureToggleSelector(state).isNewbuildingBrokerFlatBannerRedesignEnabled;
};
